module.exports = __webpack_public_path__ + "img/2-4.606b1383.png";